






















import { Component, Prop, Mixins } from 'vue-property-decorator';
import CalendarEventData from '@/ts/CalendarEventData';
import { Mutations, Views, ViewModes } from '@/ts/store/Constants';
import DateMethods from '@/mixins/DateMethods.vue';
import moment from 'moment';

@Component
export default class CalendarEventList extends Mixins(DateMethods) {
    @Prop() public feedItemData!: CalendarEventData;

    constructor() {
        super();
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get dataLoaded() {
        return (this.feedItemData !== null);
    }

    get isImportantClass(): object {
        return {
            'hococo-feed-type-event' : (this.feedItemData.isImportant === false),
            'hococo-feed-type-important': (this.feedItemData.isImportant === true),
        };
    }

    public viewHandler() {
        this.$router.push({
            name: 'event',
            params: {
                eventId: this.feedItemData.id.toString(),
            },
            query: {
                notification: this.feedItemData.notificationId.toString(),
            },
        });

        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Events,
            viewMode: ViewModes.Events.SingleEventView,
        });
    }
}
